<div class="tableDataMyRequests">
    <div class="table-margin">
        <table matSort mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)" class="mat-elevation-z8 table-width shadow-sm"> 
            <ng-container [matColumnDef]="column.columnDef" *ngFor="let column of columns; let i = index">
                <!-- Checkbox Column -->
                <ng-container *ngIf="column.columnDef==='select'; else notSelect">
                    <th mat-header-cell *matHeaderCellDef [style.width]="column.width">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null" [disabled]="column.disable"  style="margin-top: 0.4rem;"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                    >
                    </mat-checkbox>
                    </th>
             
                </ng-container>

                <ng-template #notSelect>
                    <th mat-header-cell mat-sort-header *matHeaderCellDef class="header-color tabl-header" 
                    [style.textAlign]="column.textAlign" [style.width]="column.width" [style.padding]="column.padding" 
                    [style.marginLeft]="column.marginLeft" [disabled]="!column.isSort" [ngClass]="{'align-cancel-header': column.displayText === 'Cancel'}">
                        {{ column.header }}
                        <span *ngIf="column.filter">
                            <span *ngIf="!filterApplied[i]" (click)="filterDropdown(column, i);$event.stopPropagation()" [matMenuTriggerFor]="contextMenu" #trigger="matMenuTrigger">
                                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter.png">
                            </span>
                            <span *ngIf="filterApplied[i]" (click)="filterDropdown(column, i);$event.stopPropagation()" [matMenuTriggerFor]="contextMenu" #trigger="matMenuTrigger">
                                <img class="stkh-table-filter-img" src="../../../../assets/images/table_filter_applied.png">
                            </span>
                        </span>
                        <mat-menu #contextMenu="matMenu">
                            <div class="menu-filter-popup" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
                            <input matInput type="text" (keydown)="$event.stopPropagation()" (input)="searchFunction(column)"
                                class="form-control searchoption filter-search-bar" [(ngModel)]="searchTxt"
                                placeholder="Search" />
                            <mat-selection-list class="filter-list-container" (selectionChange)="selectionChange($event, column, i)"
                                [disableRipple]="true" [(ngModel)]="filValue">
                                <ng-container *ngIf="searchTxt ==''">
                                    <mat-list-option checkboxPosition="before" *ngFor="let row of filterLists" [value]="row">
                                        {{ row }}
                                    </mat-list-option>
                                </ng-container>
                                
                                <ng-container *ngIf="searchTxt != ''">
                                    <mat-list-option checkboxPosition="before" *ngFor="let row of searchFilterLists" [value]="row">
                                        {{ row }}
                                    </mat-list-option>
                                </ng-container>
                            </mat-selection-list>
                            <span style="cursor:pointer; float: right;padding-right: 70px;" class="small localApplyButton"
                                (click)="applyLocalFilter(column, i);$event.stopPropagation();">Apply</span>
                            <span style="cursor:pointer; float: right;padding-right: 22px;" class="small localApplyButton"
                                (click)="clearLocalFilter(column, i);$event.stopPropagation();">Clear</span>
                                <div class="clear"></div>
                            </div>
                        </mat-menu>
                        <span class="d-flex my-requests-clear-filter" *ngIf="showResetFilters && (column.columnDef=='reset_filter')" (click)="clearallFilter()">
                            &nbsp;
                            <i title="Reset Filters"
                                class="font-weight-bold ng-tns-c441-21 sm-icon stkh-table-filter-img uitk-icon uitk-icon-refresh"></i>
                        </span>
                    </th>
                    <td mat-cell *matCellDef="let element;  let j = index" [style.textAlign]="column.textAlign" [style.padding]="column.padding"> 
                        <ng-container *ngIf="column.link; else nonLinkColumn">
                            <span *ngIf="column.columnDef == 'Request_Id'" (click)="getRecord(element)" title="Click here to View more details." class="link-click">{{ element[column.columnDef] }}</span>
                            <span >
                        </span >
               

                        </ng-container>
                        <ng-template #nonLinkColumn>
                            <ng-container [ngSwitch]="column.displayText">


                                <ng-container  >
                                   <span *ngIf=" column.columnDef !== 'Action' && column.columnDef !== 'created_at' && column.columnDef !== 'updated_at' && column.columnDef !== 'Req_Status'&& column.columnDef !== 'completed_by' && column.columnDef !== 'completed_at'"> {{ element[column.columnDef] }}</span>
                                   <span *ngIf=" column.columnDef == 'created_at' || column.columnDef == 'updated_at' "> {{ element[column.columnDef] | date:'MMM d, y':'UTC' }}</span>
                                   <span *ngIf="column.columnDef == 'rejected_at'">{{element[column.displayText] | date:'MMM d, y':'UTC'}}</span>
                                   <span *ngIf="column.columnDef == 'rejected_by'">{{element[column.displayText]}}</span>
                                   <span *ngIf="column.columnDef === 'Req_Status' ">
                                        
                                    {{ element['Approver_Justification1'] !== null && element['Req_Justification2'] === null ? 'Information Requested' : 'Open' }}
                                </span>

                                <span *ngIf="column.columnDef == 'completed_at'">
                                {{element['Approver_2_timestamp'] ? (element['Approver_2_timestamp'] | date:'MMM d, y':'UTC') : element['Approver_1_timestamp'] ? (element['Approver_1_timestamp'] | date:'MMM d, y':'UTC') : ''}}
                                </span>

                                <span *ngIf="column.columnDef == 'completed_by'">
                                    {{element['Approver_2_Name'] ? (element['Approver_2_Name']) : element['Approver_1_Name'] ? (element['Approver_1_Name']) : ''}}
                                    </span>
                                   

                                    <span *ngIf="column.columnDef == 'Action'">
                                        <button class="uitk-c-button uitk-c-button--default mat-mdc-raised-button
                                        uitk-u-margin-right--base techops-global-button" (click)="onCancelClick(element)">
                                            Cancel
                                       </button>
                                    </span>
                                </ng-container>
                            </ng-container>

                        </ng-template>
                    </td>
                </ng-template>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row style="min-height: 10% !important;" *matRowDef="let element; columns: displayedColumns" class="example-element-row pt-2 pb-2"></tr>

            <ng-container matColumnDef="nodata">
                <td mat-footer-row *matFooterCellDef [colSpan]="displayedColumns.length" style="text-align: center;">
                    <div class="no-records-found">
                        <div class="img-align">
                            <img class="image-align" src="/assets/images/warning-icon.svg" />
                        </div>
                        <div class="data-title">
                            <div class="errorTitle">No Data Available</div>
                        </div>
                    </div>
                </td>
            </ng-container>
            <tr mat-footer-row [hidden]="dataSource && dataSource.data.length >0" *matFooterRowDef="['nodata']"> </tr>

        </table>
        <ng-container>
            <ng-container >
                <mat-paginator [pageSize]="5"
                [length]="dataSource?.data?.length" [pageSizeOptions]="[5,10,15]" showFirstLastButtons></mat-paginator>
            </ng-container>
        </ng-container>
    </div>
</div>

<div *ngIf="!receivedData" class="uitk-l-grid__col--12 prop-loader">
    <app-loader *ngIf="!receivedData" class="load-center"></app-loader>
  </div>

<app-modal [maximizable]="true" [inViewport]="true" #cancelOpenRequest class="modal-demo add-comment-modal">
    <ng-container class="app-modal-header">Cancel Request</ng-container>
    <ng-container class="app-modal-body">
        <div class="mb-2">
            <p>Are you sure you want to cancel the request?</p>
        </div>
    </ng-container>
    <ng-container class="app-modal-body">
                <div class="add-edit-master-data-block">


                    <div style="width: auto;">
                        <p style="color: #013B71;font-weight: bold;">Comment
                            <span class="mandate-asterisk uitk-icon uitk-icon-asterisk sm-icon"></span>
                        </p>
                        <div class="form-field">
                            <p class="m-0"><textarea placeholder="Please enter your Justification" (input)="fieldValueChange()" name='comment' [(ngModel)]="comment" class="w-100 form-control comments-input" rows="4"></textarea></p>
                        </div>
                    </div>
                
                
                        <button style="float: right;" [disabled]=!isInValidData
                            class="m-3 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
                            (click)="confirmCancel()"> Continue
                        </button>
                
                </div>
    </ng-container>
</app-modal>
<app-modal [maximizable]="true" [inViewport]="true" #modalRoot class="modal-demo req-details-popup" (closeModal)="onModalClose()">
    <ng-container class="app-modal-header">Request ID : {{selectedRequestId}} | Status : {{ selectedElement?.Req_Status == 'Open' && selectedElement?.Approver_Justification1 !== null && selectedElement?.Req_Justification2 === null ? 'Information Requested' : selectedElement?.Req_Status}}</ng-container>
    <ng-container class="app-modal-body">
        <app-proposal-popup [propDataSource]="inputDataSource" [selectedRequestId]="selectedRequestId" (hidePopup)="hidecancelpopup()" [selectedOption]="selectedOption" [closedProposalPopup]="closedProposalPopup"></app-proposal-popup>
    </ng-container>
</app-modal>

